import { render } from "./ImageEditButton.vue?vue&type=template&id=180e63de&scoped=true"
import script from "./ImageEditButton.vue?vue&type=script&lang=js"
export * from "./ImageEditButton.vue?vue&type=script&lang=js"

import "./ImageEditButton.vue?vue&type=style&index=0&id=180e63de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180e63de"]])

export default __exports__